import useRewardsById from "hooks/useRewardsById";
import { useImagePath } from "hooks/useImagePath";
import { Check, RewardImageBox, RewardImg, RewardText } from "./style";
import { FriendReferralTierReward } from "interfaces";
import { friendCenterAssets } from "assets/cdn";

const RewardImage = ({
	reward,
	completed
}: {
	reward: FriendReferralTierReward;
	completed: boolean;
}) => {
	const { getImage } = useImagePath("cdn");
	const displayReward = useRewardsById(reward.rewardId as string);
	const checkmarkImage = getImage(friendCenterAssets.friendInvite.checkmark);

	return (
		<RewardImageBox completed={completed}>
			<RewardImg
				className={completed ? "completed" : ""}
				src={
					displayReward?.[0]?.imageUrl || displayReward?.[0]?.overrideImageUrl
				}
				alt={`Reward ${displayReward?.[0]?.singularLabel}`}
			/>
			<RewardText>
				{displayReward?.[0]?.description && !completed ? (
					new Intl.NumberFormat("en-US", {
						notation: "compact",
						compactDisplay: "short",
						maximumFractionDigits: 1,
						roundingMode: "floor"
					}).format(
						Number(displayReward?.[0]?.description?.replaceAll(",", ""))
					)
				) : (
					<>
						{completed && (
							<Check>
								<img src={checkmarkImage} alt="" />
							</Check>
						)}
					</>
				)}
			</RewardText>
		</RewardImageBox>
	);
};

export default RewardImage;
